module.exports = __webpack_public_path__ + "static/media/wce.8b3becf4.svg";